
import { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay";

import axios from "../../../axios/axios";
import moment from "moment";
import { DATE_TIME_FORMAT } from "../../../constants/constants";
import DataTable from "react-data-table-component";
import { useParams } from "react-router-dom";
import { Button, Dropdown, Form } from "react-bootstrap";
import { ThreeDot } from "../../../assets/images";
import { message } from "antd";
import { CSVLink } from "react-csv";
import { useHistory } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";

const CorporateMember = () => {
  const { id } = useParams();
  const [loader, setLoader] = useState(false);
  const [members, setMember] = useState([]);
  const history = useHistory();
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [csvData, setCsvData] = useState([]);
  const [filter, setFilter] = useState({
    search: "",
    startDate: "",
    endDate: "",
  });
  const [passwordShowHide, setpasswordShowHide] = useState(null);
  const [arriviaPasswordShowHide, setArriviaPasswordShowHide] = useState(null);
  const [search, setSearch] = useState({ search: "", startDate: "", endDate: "" });
  useEffect(() => {
    getMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit, page, search]);

  const getMembers = () => {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("AuthToken")}` },
    };

    setLoader(true);

    axios.get(
      `/advantage-member/get-corporate-member-admin/${id}?page=${page}&limit=${limit}&search=${search?.search}&startDate=${search?.startDate}&endDate=${search?.endDate}`,
      config
    )
      .then((res) => {
        setLoader(false);
        if (res.data.status) {
          setMember(res.data.data);
          setTotal(res.data.pagination?.total);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.error(err);
      });
  };


  const toggleStatus = (email, type) => {
    setLoader(true);
    axios
      .patch(`/advantage-member/admin-client-member-active-inactive/${type}/${email}/${id}`)
      .then((res) => {
        setLoader(false);
        if (res.data.status) {
          message.success(res.data.message);
          getMembers();
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.error(err);
      });
  };
      const showHidePasswordFun = (id) => {
    setpasswordShowHide(id);
  };
  const showHideArriviaPasswordFun = (id) => {
    setArriviaPasswordShowHide(id);
  };
  const columns = [
    {
      name: "Member Name",
      selector: (row) => row.memberName,
      sortable: true,
    },
    {
      name: "Member Email",
      selector: (row) => row.memberEmail,
      sortable: true,
    },
    {
      name: "Member Username",
      selector: (row) => row.memberUserName,
      sortable: true,
    },

    {
      name: "Created At",
      selector: (row) => moment(row.createdAt).format(DATE_TIME_FORMAT),
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.statusType,
      sortable: true,
    },
              {
      name: "Password",
      selector: (row) => (
        row?.isPasswordShow ? (
        <div>
          {passwordShowHide === row?.corporateMemberUserId ? (
            <>
              <span>{row?.passwordRaw}</span>
              <button
                type="button"
                className="btn btn-primary btn-sm ml-3"
                onClick={() => {
                  showHidePasswordFun(null);
                }}
              >
                Hide
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="btn btn-primary btn-sm ml-3"
                onClick={() => {
                  showHidePasswordFun(row.corporateMemberUserId);
                }}
              >
                Show
              </button>
            </>
          )}
        </div>
        ):(
            <span>N/A</span>
        )
      ),
      sortable: true,
      width: "130px",
      wrap: true
    },
          {
      name: "Arrivia Password",
      selector: (row) => (
        row?.arriviaPassword ? (
        <div>
          {arriviaPasswordShowHide === row?.corporateMemberUserId ? (
            <>
              <span>{row?.arriviaPassword}</span>
              <button
                type="button"
                className="btn btn-primary btn-sm ml-3"
                onClick={() => {
                  showHideArriviaPasswordFun(null);
                }}
              >
                Hide
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="btn btn-primary btn-sm ml-3"
                onClick={() => {
                  showHideArriviaPasswordFun(row.corporateMemberUserId);
                }}
              >
                Show
              </button>
            </>
          )}
        </div>
        ):(
            <span>N/A</span>
        )
      ),
      sortable: true,
      width: "130px",
      wrap: true
    },
    {
      name: "Action",
      selector: (row) => (
        <Dropdown drop="down" className="select_box_preassigneds">
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            <img src={ThreeDot} alt="Action" />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <div
              className="dropdown-item"
              role="button"
              onClick={() => {
                toggleStatus(row?.memberUserName, row?.status ? "inactive" : "active");
              }}
            >
              {row?.status ? "Inactive" : "Active"}
            </div>
          </Dropdown.Menu>
        </Dropdown>
      ),
      width: "200px",
    },
  ];
  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
      },
    },
    headCells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
        fontSize: "17px",
        color: "#004aad",
      },
    },

    cells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
        fontSize: "16px",
      },
    },
  };

  const headersForAdv = [
    { label: "Member Name", key: "memberName" },
    { label: "Member Email", key: "memberEmail" },
    { label: "Member Username", key: "memberUserName" },
    { label: "Created At", key: "createdAt" },
    { label: "Status", key: "statusType" },
  ];
  const downloadCsv = () => {

    axios.get(
      `/advantage-member/get-corporate-member-admin-download-csv/${id}?search=${search?.search}&startDate=${search?.startDate}&endDate=${search?.endDate}`,
    )
      .then((res) => {
        if (res.data.status) {
          const formatData = res.data.data?.map(item => {
            item.createdAt = moment(item.createdAt).format(DATE_TIME_FORMAT);
            return item;
          });
          setCsvData(formatData);
          setTimeout(() => {
            document.getElementById("csv-download-link").click();
          }, 100);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  return (
    <LoadingOverlay active={loader} spinner text="Loading ...">
      <section className="right_cont">

        <div className="right_banner_banner_cnt">
          <div className="certificate-heading">
            {/* Add go back button */}
            <Button
              variant="dark"
              onClick={() => history.goBack()}
            >
              <IoMdArrowRoundBack />
              Go Back
            </Button>
            <h2>View Member's List</h2>
          </div>
          <div className="mt-3 row mb-3">
            <div className="col-md-4">
              <label htmlFor="name">Name, Email, Username</label>
              <Form.Control
                type="text"
                name="search"
                value={filter.search}
                onChange={(e) => setFilter({ ...filter, search: e.target.value })}
                placeholder="Search by name or email or username"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor="startDate">Start Date</label>
              <Form.Control
                type="date"
                value={filter.startDate}
                onChange={(e) => setFilter({ ...filter, startDate: e.target.value })}
                name="startDate"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor="endDate">End Date</label>
              <Form.Control
                type="date"
                value={filter.endDate}
                onChange={(e) => setFilter({ ...filter, endDate: e.target.value })}
                name="endDate"
              />
            </div>
            <div className="col-md-1 mt-4">
              <Button
                onClick={() => {
                  setSearch({ ...filter });
                  setPage(1);
                }}
              >
                Search
              </Button>
            </div>
            <div className="col-md-1 mt-4">
              <Button
                variant="dark"
                onClick={() => {
                  setFilter({ search: "", startDate: "", endDate: "" });
                  setSearch({ search: "", startDate: "", endDate: "" });
                  setPage(1);
                }}
              >
                Clear
              </Button>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-12 text-right">
              <Button className="btn btn-primary" onClick={downloadCsv}>
                Download CSV
              </Button>

              <CSVLink
                data={csvData}
                headers={headersForAdv}
                filename={`corporate-member_${Date.now()}.csv`}
                className="hidden"
                id="csv-download-link"
                target="_blank"
              />
            </div>
          </div>
          <div className="cert_det_inner">
            <DataTable
              columns={columns}
              data={members}
              highlightOnHover
              pagination
              striped
              responsive
              paginationServer
              paginationTotalRows={total}
              customStyles={customStyles}
              subHeaderAlign="right"
              paginationPerPage={limit}
              paginationRowsPerPageOptions={[10, 20, 50]}
              onChangePage={(newPage) => setPage(newPage)}
              className={members.length === 1 ? "search_state" : ""}
              onChangeRowsPerPage={(newLimit) => {
                setLimit(newLimit);
                setPage(1);
              }}
            />
          </div>
        </div>
      </section>
    </LoadingOverlay>
  );
};

export default CorporateMember;
